<template>
  <div class="w-full pt-5">
    <div class="flex w-full mt-1">
      <h1 class="text-xl text-left font-extrabold pl-4 mr-8">
        Performance Appraisals
      </h1>
      <Breadcrumb :items="breadcrumbs" />
    </div>
    <template>
      <div class="w-full p-5 flex mt-1 flex-col">
        <MyAppraisals />
      </div>
    </template>
  </div>
</template>

<script>
import Breadcrumb from "@scelloo/cloudenly-ui/src/components/bread-crumb";
import Loader from "@scelloo/cloudenly-ui/src/components/loader";
import MyAppraisals from "./Tabs/MyAppraisals";

export default {
  name: "EssPerformanceAppraisals",
  components: {
    Breadcrumb,
    Loader,
    MyAppraisals,
  },
  data() {
    return {
      openModal: false,
      isLoading: false,
      breadcrumbs: [
        {
          disabled: false,
          text: "Performance Management",
          href: "Performance",
          id: "Performance",
        },
        {
          disabled: false,
          text: "My Appraisals",
          href: "performance-appraisls",
          id: "PerformanceAppraisals",
        },
      ],
    };
  },

  methods: {
  },

  mounted() {
  },
};
</script>